import React, { Fragment, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { AppLoader, FormButtons, Button, Title } from "@portal/kit/pkg/components"

import SelectedOffer from './selected-offer'
import { PaymentContext } from 'components/providers/payment'
import { useParams } from 'react-router-dom'

export default function OfferDetail() {
  const { t } = useTranslation()
  const { catalogs, selectedCatalog, selectedOffer, getOffer } = useContext(PaymentContext)
  const { offerId } = useParams()

  useEffect(() => {
    getOffer(offerId)
  }, [getOffer, offerId])

  if (!catalogs || !selectedOffer || !selectedCatalog) return <AppLoader />

  return (
    <Fragment>
      <Title>{t('portal.offers.offer_detail_title')}</Title>
      <SelectedOffer offer={selectedOffer} catalog={selectedCatalog} isDetailed />
      <FormButtons>
        <Button classType="cancel" to='/offers'>{t('portal.offers.previous')}</Button>
        <Button to={`/offers/${offerId}/checkout`}>{t('portal.offers.buy')}</Button>
      </FormButtons>
    </Fragment>
  )
}
